var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg149Diagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71,340.846c11.046,0,20-8.954,20-20V301c0-22.056,17.944-40,40-40h105v60c0,11.046,8.954,20,20,20s20-8.954,20-20v-60 h105c22.056,0,40,17.944,40,40v19.846c0,11.046,8.954,20,20,20c11.046,0,20-8.954,20-20V301c0-44.112-35.888-80-80-80H276v-91h32 c11.046,0,20-8.954,20-20V20c0-11.046-8.954-20-20-20H204c-11.046,0-20,8.954-20,20v90c0,11.046,8.954,20,20,20h32v91H131 c-44.112,0-80,35.888-80,80v19.846C51,331.892,59.954,340.846,71,340.846z M224,90V40h64v50H224z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492,382H389c-11.046,0-20,8.954-20,20v90c0,11.046,8.954,20,20,20h103c11.046,0,20-8.954,20-20v-90 C512,390.954,503.046,382,492,382z M472,472h-63v-50h63V472z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,382H20c-11.046,0-20,8.954-20,20v90c0,11.046,8.954,20,20,20h103c11.046,0,20-8.954,20-20v-90 C143,390.954,134.046,382,123,382z M103,472H40v-50h63V472z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,382H204c-11.046,0-20,8.954-20,20v90c0,11.046,8.954,20,20,20h104c11.046,0,20-8.954,20-20v-90 C328,390.954,319.046,382,308,382z M288,472h-64v-50h64V472z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg149Diagram);
export default __webpack_public_path__ + "static/media/149-diagram.b9e872d442d92b537e4153b3e282769d.svg";
export { ForwardRef as ReactComponent };